import React, { useEffect, useState } from "react";
import { Swords } from "lucide-react";
import { fetchActiveBattleForCategory } from "../../../api/battleService";

export default function RoomBattleBanner({ categorySlug }) {
  const [battle, setBattle] = useState(null);

  useEffect(() => {
    if (!categorySlug) return;
    const controller = new AbortController();
    fetchActiveBattleForCategory(categorySlug, controller.signal)
      .then((data) => setBattle(data))
      .catch(() => {});
    return () => controller.abort();
  }, [categorySlug]);

  if (!battle) return null;

  const startsAt = new Date(battle.starts_at);
  const now = new Date();
  const minutesUntil = Math.round((startsAt - now) / 60000);
  const isActive = battle.status === "open" || minutesUntil <= 0;

  const timeLabel = isActive
    ? "Battle en cours"
    : minutesUntil <= 60
    ? `Battle dans ${minutesUntil} min`
    : `Battle a ${startsAt.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })}`;

  return (
    <div className="flex items-center gap-2 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-2 text-sm font-semibold text-amber-800">
      <Swords className="h-4 w-4 shrink-0 text-amber-600" />
      <span>
        {timeLabel}
        {battle.title ? ` — ${battle.title}` : ""}
        {battle.creator?.username ? ` (organisee par ${battle.creator.username})` : ""}
      </span>
    </div>
  );
}
